<div class="customer-view-tab" [class.customer-view-tab--variant-modal]="variantModal()">
  <div class="customer-view-tab__inner">
    <div class="customer-view-tab__inner-content">
      <fr8bot-ui-content-border-shadow [sides]="['left', 'right']" />
      <ng-content />
    </div>
  </div>
</div>
